import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as firebase from 'firebase';

import { Company, Address } from '../../model/company';
import { AuthenticationService } from '../../services/authentication.service';
import { LocationService } from '../../services/location.service';
import { User } from '../../model/user';
import { DBService } from '../../services/db.service';
import { Partner } from '../../model/partner';
import { Employee } from '../../model/employee';
import { Segment } from '../../model/segments';

declare var Materialize: any;

@Component({
  selector: 'app-new-company',
  templateUrl: './new-company.component.html',
  styleUrls: ['./new-company.component.css'],
  providers: [LocationService, DBService]
})
export class NewCompanyComponent implements OnInit {

  phoneMask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  cepMask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  public cnpjMask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

  company: Company;
  confirmPassword: string;

  isConfirmPasswordWrong: boolean;

  successMessage: string;
  errorMessage: string;

  loading: boolean;

  isSaving: boolean;
  isSearching: boolean;
  hasAddress: boolean;
  isUploadingFile: boolean;

  user: User;

  newProduct: string;

  companies: Company[];
  partners: Partner[];

  isIGanhei: boolean;

  segments: Segment[];

  constructor(private router: Router, private authService: AuthenticationService, private locationService: LocationService, private dbService: DBService) {
    this.company = new Company();
    this.company.products = [];
    this.company.address = new Address();

    this.loadUser();
    this.loadCompanies();
    this.loadPartners();
    this.loadSegments();
  }

  private loadSegments() {
    this.dbService.listWithUIDs<Segment>('segments')
      .then(segments => {
        this.segments = segments;
      });
  }

  private loadCompanies() {
    this.dbService.listWithUIDs<Company>('/companies')
      .then(companies => {
        this.companies = companies;
      })
      .catch(error => console.log(error));
  }

  private loadPartners() {
    this.dbService.listWithUIDs<Partner>('/partners')
      .then(partners => {
        this.partners = partners;
      })
      .catch(error => console.log(error));
  }

  ngOnInit() {
  }

  private loadUser() {
    this.authService.getCurrentUser().subscribe(currentUser => {
      this.user = new User();

      if (currentUser != null) {
        this.user.uid = currentUser.uid;
        this.user.email = currentUser.email;

        this.loadEmployee();
      }
    });
  }

  private loadEmployee() {
    this.dbService.getObject<Employee>(`/employees/${this.user.uid}`)
      .then(employee => {
        this.isIGanhei = this.user.email.includes('@iganhei.com') || employee.companyUID === 'I-Ganhei';
      })
      .catch(error => console.log(error));
  }

  addProduct() {
    this.company.products.push(this.newProduct);
    this.newProduct = '';
  }

  removeProduct(product) {
    this.company.products = this.company.products.filter(p => p !== product);
  }

  register() {
    delete this.errorMessage;
    delete this.successMessage;

    this.loading = true;

    this.authService.insertInList<Company>('/companies', this.company)
      .then(() => this.registerSuccess())
      .catch(error => this.registerError(error))
  }

  private registerSuccess() {
    this.loading = false;

    Materialize.toast('Empresa cadastrada com sucesso', 2000);

    this.router.navigate(['/empresas']);
  }

  private registerError(error) {
    this.errorMessage = error;
    this.loading = false;
  }

  cancel() {
    this.router.navigate(['/empresas']);
  }

  searchCep() {
    this.hasAddress = false;
    this.isSearching = true;

    this.locationService.getAddress(this.company.address.cep)
      .then(address => {
        address.cep = this.company.address.cep;
        this.company.address = address;
        this.isSearching = false;

        this.hasAddress = true;
        this.updateLabels();
      })
      .catch(error => {
        console.log(error);
        this.isSearching = false;
      })
  }

  public fileChangeEvent(fileInput: any){
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.uploadImage();
  }
}

uploadImage() {
  this.isUploadingFile = true;
  let storage = firebase.storage().ref();
  let path = '/restaurants/';
  let files = [(<HTMLInputElement>document.getElementById('image')).files[0]];

  for(let image of files) {
    storage.child(path + image.name).put(image)
      .then((result) => {
        this.company.photoURL = result.downloadURL;
        this.company.photoURL = result.downloadURL;
        this.isUploadingFile = false;
      });
    }
  }

  private updateLabels() {
    setTimeout(() => Materialize.updateTextFields(), 100);
  }

  onChangeFirstFee(event) {
    const dateParts = this.company.firstFeeDateString.split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.company.firstFeeDate;
    } else {
      this.company.firstFeeDate = date.getTime();
    }
  }

  onChangeContract(event) {
    const dateParts = this.company.contractDateString.split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.company.contractDate;
    } else {
      this.company.contractDate = date.getTime();
    }
  }

  onChangeDate(event, propertyString, propertyDate) {
    const dateParts = this.company[propertyString].split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.company[propertyDate];
    } else {
      this.company[propertyDate] = date.getTime();
    }
  }

  onChangeCancel(event) {
    const dateParts = this.company.contractCancelDateString.split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.company.contractCancelDate;
    } else {
      this.company.contractCancelDate = date.getTime();
    }
  }

  changeSource() {
    this.company.salesPerson = '';
    this.company.salesPersonCommission = '';
    this.company.manager = '';
    this.company.managerCommission = '';

    this.company.otherComment = '';

    this.company.indicatingCustomerUID = '';

    this.company.indicatingPartnerUID = '';
    this.company.paymentType = 0;

    this.company.firstMonthDate = null;
    this.company.firstMonthDateString = '';
    this.company.lastMonthDate = null;
    this.company.lastMonthDateString = '';

    this.company.firstCommissionDate = null;
    this.company.firstCommissionDateString = '';
    this.company.lastCommissionDate = null;
    this.company.lastCommissionDateString = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/new-company/new-company.component.ts